import React, {} from 'react';

import { ReactComponent as CloseIcon } from 'assets/images/close-button-icon.svg';

import './index.scss';

function MeetingAttendee(props) {

  function renderRemoveContactItemControl(contact) {

    if (props.disabled === true) {
      return;
    }

    if (props.canRemove(contact) === false) {
      return;
    }

    const closeButtonAttributes = {
      className: 'application-button round-button contact-profile-remove-button',
      onClick() {
        props.onRemove(contact);
      }
    };

    return <button {...closeButtonAttributes}>
      <CloseIcon />
    </button>;
  }

  function renderAttendeeStatus(contact) {

    let status = 'pending';

    if (contact.metadata !== void 0) {
      status = contact.metadata.status.toLowerCase();
    }

    const statusAttributes = {
      className: 'contact-profile-status ' + status
    };

    return <span {...statusAttributes}></span>;

  }

  function renderMain() {

    const contact = props.contact;

    const contactAttributes = {
      className: 'contact-item meeting-attendee-item'
    };

    if (typeof contact === 'string') {

      contactAttributes.className += ' three-column-grid';

      return <div {...contactAttributes}>

        <span className="contact-profile-username ellipsis">{contact}</span>
        {renderAttendeeStatus(contact)}
        {renderRemoveContactItemControl(contact)}

      </div>;

    }

    contactAttributes.className += ' four-column-grid';

    const profilePictureURL = contact.profilePicture.url;

    const contactProfileImageAttributes = {
      src: profilePictureURL,
      className: 'contact-profile-picture'
    };

    const contactProfileImageDescription = `${contact.name} Profile Image`;

    return <div {...contactAttributes}>

      <img {...contactProfileImageAttributes} alt={contactProfileImageDescription} />
      <span className="contact-profile-username ellipsis">{contact.name} {' '}<span className="application-sub-text">({contact.value})</span></span>
      {renderAttendeeStatus(contact)}
      {renderRemoveContactItemControl(contact)}

    </div>;

  }

  return renderMain();

}

export default MeetingAttendee;